import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import whyHrmsImage from "../../assets/service/whyHrmsImage.png";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import BookDemoModal from "../../landing-hrms/sections/DemoModal";
import { useState } from "react";
import { Helmet } from "react-helmet";
import check_icon from "../../assets/service/check_icon.webp";


import "./whyOurHRSoftware.css";
const WhyChooseOurHRSoftware = () => {
    const [showContactModal, setShowContactModal] = useState(false);
    return (
        <>
            <Helmet>
                <title>
                    Why Choose Our HRMS Software for Business Growth | TechCognics
                </title>

                <meta
                    name="description"
                    content="Discover why businesses choose TechCognics HRMS software to automate payroll, attendance, compliance, and employee management with accuracy, security, and scalability."
                />

                <meta
                    name="keywords"
                    content="best HRMS software, HR software benefits, HRMS advantages, HR management solution, scalable HR software, HRMS for businesses, cloud HRMS system"
                />

                <meta
                    property="og:title"
                    content="Why Choose Our HRMS Software for Business Growth"
                />

                <meta
                    property="og:description"
                    content="Automate HR operations with TechCognics HRMS. Improve payroll accuracy, reduce errors, and scale employee management effortlessly."
                />

                <meta property="og:type" content="website" />
            </Helmet>

            <div id="why-hrms" className="about__one section-padding mt-lg-5 mt-md-0 bg-light">
                <div className="container">
                    <div className="row  flex-wrap-reverse gy-4 whyHrmsTabViewMngment">
                        <div className="col-xl-6 col-lg-6 col-md-12">
                            <div className="about__one-images">
                                <div className="about__one-image-wrapper whyOurHrms">
                                    <img
                                        src={whyHrmsImage}
                                        alt="HRMS software dashboard for payroll and employee management"
                                        className="image-1"
                                    />                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-12">
                            <div className="about__one-content">
                                <div className="text-start feature-heading" style={{ color: '#0F4F93' }}>Why HRMS?</div>
                                <p className="text-start">HRMS is one of the most endorsed and applied employee-self-service applications to transform diverse HR operations into automated mobile utility.</p>
                                <div className="about__one-content-service-whyus ">
                                    <div className="service">
                                        {/* <TaskAltIcon className="me-3"
                                            style={{ color: "#4fc3f7" }}
                                        /> */}
                                        <img src={check_icon} width="20" height="20" class="img-fluid me-3 mt-1" alt="checkmark"></img>
                                        <span>Full-service employee dashboard

                                        </span>
                                    </div>
                                    <div class="service">
                                        <img src={check_icon} width="20" height="20" class="img-fluid me-3 mt-1" alt="checkmark"></img>

                                        <span>Asset and data management
                                        </span>
                                    </div>
                                    <div class="service">
                                        <img src={check_icon} width="20" height="20" class="img-fluid me-3 mt-1" alt="checkmark"></img>

                                        <span>Payroll and leave management    </span> 
                                    </div>
                                    <div class="service">
                                        <img src={check_icon} width="20" height="20" class="img-fluid me-3 mt-1" alt="checkmark"></img>

                                        <span>Employee performance data</span>
                                    </div>
                                    <div class="service">
                                        <img src={check_icon} width="20" height="20" class="img-fluid me-3 mt-1" alt="checkmark"></img>

                                        <span>Policy walkthroughs and announcements</span>
                                    </div>
                                    <div class="service">
                                        <img src={check_icon} width="20" height="20" class="img-fluid me-3 mt-1" alt="checkmark"></img>

                                        <span>
                                            Remote attendance and time logs</span>
                                    </div>
                                    <div class="service">
                                        <img src={check_icon} width="20" height="20" class="img-fluid me-3 mt-1" alt="checkmark"></img>

                                        <span>
                                            Employee directory and records</span>
                                    </div>
                                </div>
                                <button onClick={() => setShowContactModal(true)} className="btn-two">
                                    Book Demo <span className="btn-icon"><ArrowForwardIcon fontSize="small" /></span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <BookDemoModal
                showDemo={showContactModal}
                handleDemoClose={() => setShowContactModal(false)}
            />

        </>


    );
};

export default WhyChooseOurHRSoftware;
